import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/images/website/logo.png"



const SidebarLink = (props) => {
  const { data, index, currentPath, isexpand } = props;
  let paths = currentPath.split("/");
  paths = paths[2];

  return (
    <Link
      to={`${data.userId}`}
      className="dashboard-sidebar-middle-menu-closed tooltipp-container"
      key={index}
    >
      <div className="tooltippp" dangerouslySetInnerHTML={{ __html: data.userId === paths ? data.svgfill : data.svg }} />
      <div className="tooltipp">
        {data.name}
      </div>
    </Link>
  );
};

const DashboardSidebar = (props) => {
  const { sidebarData, isexpand, setExpanded } = props;
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  const location = useLocation();

  useEffect(() => {
    setCurrentPath(window.location.pathname);
  }, [location]);

  const handleSpanClick = () => {
    setExpanded(false);
    sessionStorage.setItem("isExpanded", false);
  };


  const handleSpanClicked = () => {
    setExpanded(true);
    sessionStorage.setItem("isExpanded", true);
  };


  return (
    <div className={isexpand ? "dashboard-main-sidebar-section" : "dashboard-main-sidebar-section-closed"}>
      <div>
        <img className="sidebar-closed-logo-cipl" src={logo} alt="logo" />

      </div>

      <div className="sidebar-title">
        Menu
      </div>
      <div>
        {sidebarData.map((data, index) => {
          // console.log(data.userId + " " + data.subMenu);
          return data.subMenu ? (
            // <SidebarDropDown
            //   data={data}
            //   currentPath={currentPath}
            //   index={index}
            //   isexpand={isexpand}
            // />
            ""
          ) : (
            <SidebarLink data={data} currentPath={currentPath} index={index} isexpand={isexpand} />
          );
        })}
      </div>
    </div>
  );
};

export default DashboardSidebar